import React, { useEffect } from "react";

import { useStoreActions, useStoreState } from 'easy-peasy';
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";

import PackageFormComponent from "../../components/packages/PackageFormComponent";
import Loader from "../../components/widgets/Loader";
import useBackButton from "../../hooks/useBackButton";

const UpdatePackagePage = () => {
    const { fetchPackageById, updatePackage } = useStoreActions((actions) => actions.packages);
    const { packageById, isFetchingOnePackage } = useStoreState((state) => state.packages);
    const packagesSlugs = useStoreState((state) => state.actionSlugs.actionSlugsDispatcher("packages"));

    const { backButtonComponent } = useBackButton();

    const { uniqueId } = useParams();

    useEffect(() => {
        if (uniqueId) {
            fetchPackageById(uniqueId);
        }
    }, [uniqueId]);

    return (isFetchingOnePackage || packageById?.uniqueId !== uniqueId) ?
        <Loader />
        : <div className="container p-2">
            <Row className="mb-3">
                <Col className="d-flex justify-content-between align-items-center">
                    <h2>Mise à jour de l'application {packageById?.name}</h2>
                    {backButtonComponent}
                </Col>
            </Row>
            <PackageFormComponent
                actionFn={updatePackage}
                packageToUpdate={packageById}
                {...packagesSlugs}
            />
        </div>;
};

export default UpdatePackagePage;
